const RANKING = [
  { posicao: '🥇', nome: 'João', pontos: '12.450', destaque: true },
  { posicao: '🥈', nome: 'Maria', pontos: '10.820', destaque: false },
  { posicao: '🥉', nome: 'Carlos', pontos: '9.730', destaque: false },
  { posicao: '4º', nome: 'Fernanda', pontos: '8.150', destaque: false },
  { posicao: '5º', nome: 'Rafael', pontos: '7.420', destaque: false },
];

const TIPOS_RANKING = [
  'Por região',
  'Por produto',
  'Por equipe',
  'Por período',
  'Por campanha',
];

const META = {
  atual: 82,
  total: 100,
};

export default function RankingGamificacao() {
  return (
    <section id="ranking" className="scroll-mt-28 bg-background-50 py-20 md:py-28">
      <div className="mx-auto w-full max-w-[1240px] px-6">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.18em] text-accent-700">
              <i className="ri-trophy-line"></i>
              Gamificação
            </span>
            <h2 className="mt-5 font-heading text-3xl font-bold leading-[1.1] tracking-[-0.02em] text-foreground-950 md:text-5xl">
              Ranking e metas que <span className="text-accent-600">aumentam o valor percebido</span>
            </h2>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-600">
              Rankings em tempo real por região, produto, equipe, período e campanha — mais metas individuais que
              mantêm cada participante focado na conquista.
            </p>

            <div className="mt-8 flex flex-wrap gap-2">
              {TIPOS_RANKING.map((tipo) => (
                <span key={tipo} className="rounded-full border border-background-200 bg-background-100 px-3.5 py-1.5 text-xs font-medium text-foreground-700">
                  {tipo}
                </span>
              ))}
            </div>
          </div>

          <div className="space-y-5">
            <div className="rounded-3xl border border-background-200 bg-background-50 p-6 md:p-7">
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-base font-bold text-foreground-950">Ranking de corretores</h3>
                <span className="rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">Agosto/2026</span>
              </div>
              <div className="mt-5 space-y-2">
                {RANKING.map((item) => (
                  <div
                    key={item.nome}
                    className={`flex items-center justify-between rounded-xl px-4 py-3 ${
                      item.destaque ? 'bg-primary-50 ring-1 ring-primary-200' : 'bg-background-100'
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <span className="w-8 text-center text-base">{item.posicao}</span>
                      <span className="text-sm font-semibold text-foreground-900">{item.nome}</span>
                    </div>
                    <span className="font-heading text-sm font-bold text-foreground-950">{item.pontos}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="rounded-3xl border border-background-200 bg-background-50 p-6 md:p-7">
              <p className="text-xs font-semibold uppercase tracking-wider text-foreground-500">Meta do mês</p>
              <div className="mt-3 flex items-end justify-between">
                <div className="flex items-baseline gap-1">
                  <span className="font-heading text-4xl font-bold text-primary-600">{META.atual}</span>
                  <span className="text-sm font-medium text-foreground-500">/ {META.total} contratos</span>
                </div>
                <span className="font-heading text-lg font-bold text-foreground-900">{Math.round((META.atual / META.total) * 100)}%</span>
              </div>
              <div className="mt-4 h-3 overflow-hidden rounded-full bg-background-200">
                <div className="h-full rounded-full bg-primary-500" style={{ width: `${(META.atual / META.total) * 100}%` }}></div>
              </div>
              <p className="mt-3 text-sm text-foreground-600">Faltam {META.total - META.atual} contratos para bater a meta.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}